import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { tradeFlow } from '@/mocks/jiuchou-architecture';

export default function TransactionLayer() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="第三层 · 交易与权益层"
            title="一笔交易，如何形成完整价值链？"
            subtitle="点击任意节点，查看该环节的详细解释。从商品进入，到支付、履约、评价、贡献记录、清分，最终数据回流，形成完整价值链。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={tradeFlow} direction="horizontal" accent="primary" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}